import { useEffect, useLayoutEffect, useRef } from 'react'

function useInterval(callback, delay, preCondition) {
  const savedCallback = useRef(callback)
  const preConditionRef = useRef(preCondition)
  // Remember the latest preCondition if it changes.
  useLayoutEffect(() => {
    preConditionRef.current = preCondition
  }, [preCondition])

  // Remember the latest callback if it changes. And ensure the latest callback is called.
  // This is important because the callback is called inside the setInterval function, and
  // we want to ensure that the latest callback is used.
  useLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      return
    }

    const id = setInterval(() => {
      const shouldRun = preConditionRef.current?.() ?? true
      if (shouldRun) {
        savedCallback.current()
      }
    }, delay)

    return () => clearInterval(id)
  }, [delay])
}

export default useInterval
